import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { editRoundDate } from '../../api/editRoundDate';
import { getRoundsLeague } from '../../api/getRoundsLeague';

import FooterMenu from "../../partials/FooterMenu";
import HeaderTopic from "../../partials/HeaderTopic";
import BasicButtons from "../../partials/BasicButtons";

import styles from "./EditRoundDate.module.css";

function EditRoundDate(props) {
  const { user, league, rounds, setRounds, refreshStates } = props;
  const { leagueId, roundId } = useParams();
  const history = useHistory();
  const [roundDate, setRoundDate] = React.useState(
    rounds.filter((r) => r.id === parseInt(roundId, 10))[0].round_date
  );
  const round_number = rounds.filter((r) => r.id === parseInt(roundId, 10))[0]
    .round_number;

   const handleSubmit = async () => {
      const res = await editRoundDate(leagueId, roundId, roundDate);
      const res2 = await getRoundsLeague(leagueId);
    setRounds(res2.data);
    history.push(`/leagues/${leagueId}/rounds/${roundId}`);
  };

  return (
    <div className={styles.editRound}>
      <HeaderTopic topic={"ליגת " + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <FooterMenu setActive="vs" />

      <div className="sectionTitleSize">עריכת מחזור {round_number}</div>

      <form className="paragraphSize">
        <div>
          <span>תאריך:</span>
          <input
            type="date"
            value={roundDate}
            onChange={(e) => setRoundDate(e.target.value)}
          />
        </div>
        <div
          className={`${"btnLarge"} ${styles.submitRound}`}
          onClick={handleSubmit}
        >
          אישור
        </div>
      </form>
    </div>
  );
}

export default EditRoundDate;
